import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { EmployeeEditItemResponse } from '@modules/employees/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { EMPLOYEES_LIST_PERMISSIONS } from '@modules/employees/constants';
import { EMPLOYEE_EDIT_API_URL, EMPLOYEE_GET_EDIT_QUERY_KEY } from '@modules/employees/submodules/edit/constants';

export default function useEmployeeEditQuery(
  id: Ref<number | undefined>,
): IContextQueryResult<EmployeeEditItemResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<EmployeeEditItemResponse, Error>({
    queryKey: [EMPLOYEE_GET_EDIT_QUERY_KEY],
    queryFn: async ({ signal }) => fetchGet<EmployeeEditItemResponse>(
      EMPLOYEE_EDIT_API_URL,
      {
        signal,
        permission: EMPLOYEES_LIST_PERMISSIONS.EDIT,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
